export default __webpack_public_path__ + "static/media/cardImag1.36868a06.svg";